import * as Yup from 'yup';

export const bannerValidationSchema = Yup.object().shape({
  storeType: Yup.string().required('Store Type is required'),
  imageUrl: Yup.mixed()
    .required('Banner image is required')
    .test('fileSize', 'Image must be less than 500kb', (value: any) => {
      if (!value || typeof value === 'string') return true;
      return value.size <= 500000;
    })
    .test(
      'dimensions',
      'Image must be between 1366x300px and 1500x500px',
      (value: any): Promise<boolean> => {
        if (!value || !(value instanceof File)) return Promise.resolve(true);

        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target?.result as string;

            img.onload = () => {
              const { width, height } = img;
              resolve(
                width >= 1366 && height >= 300 && width <= 1500 && height <= 500
              );
            };

            img.onerror = () => resolve(false);
          };
          reader.readAsDataURL(value);
        });
      }
    ),
  imageTextArabic: Yup.string()
    .max(100, 'Name must be at most 100 characters')
    .matches(
      /^[\u0600-\u06FF\s]+$/,
      'Name should only contain Arabic letters and spaces'
    ),
  imageTextEnglish: Yup.string()
    .max(100, 'Name must be at most 100 characters')
    .required('please enter the imageTextEnglish'),
  buttonTextInArabic: Yup.string()
    .max(100, 'Name must be at most 100 characters')
    .matches(
      /^[\u0600-\u06FF\s]+$/,
      'Name should only contain Arabic letters and spaces'
    ),
  buttonTextEnglish: Yup.string().max(
    100,
    'Name must be at most 100 characters'
  ),
  // bannerStartTime: Yup.string().required('please enter the bannerStartTime'),
  bannerEndTime: Yup.string()
    // .required('Please enter the banner end time')
    .test(
      'is-after-start',
      'End time must be after start time',
      function (value) {
        const { bannerStartTime } = this.parent;
        if (!value || !bannerStartTime) return true;

        const start = Date.parse(bannerStartTime); // Converts to epoch ms
        const end = Date.parse(value);

        if (isNaN(start) || isNaN(end)) return false;

        return end > start;
      }
    ),
});
